import { useCallback, useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { useConfirm } from './useConfirm';

/**
 * @param {{
 *  title: string;
 *  message: string;
 *  when: Boolean;
 *  onConfirm?: () => void;
 *  onCancel?: () => void;
 * }} props
 */

export const usePrompt = (props) => {
  const { title, message, when, onCancel, onConfirm } = props;
  const { show } = useConfirm();
  const blocker = useBlocker(when);

  const confirm = useCallback(() => {
    if (!when) return Promise.resolve(true);
    return new Promise(resolve => {
      show({
        title,
        message,
        onConfirm: () => {
          resolve(true);
          onConfirm?.();
        },
        onCancel: () => {
          resolve(false);
          onCancel?.();
        }
      })
    });
  }, [title, message, when, show, onConfirm, onCancel]);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      confirm().then(result => {
        if (result) blocker.proceed();
        else blocker.reset();
      });
    }
  }, [blocker, confirm]);

  useEffect(() => {
    if (when) {
      window.onbeforeunload = () => [title, message].filter(Boolean).join('\n\n');
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [when, title, message]);

  return {
    confirm,
  };
};
